import * as React from "react";
import { OnServeTeam1Scores, OnServeTeam2Scores } from "../OnServeTeamScores";
export const BaseballLiveTableBody = (props) => {
    const { team1Name, team2Name, team1Scores, team2Scores, onServe, sportId, hasHits } = props;
    const tableBodyClass = hasHits
        ? "rj-scoreboard__live-table-body"
        : "rj-scoreboard__live-table-body rj-scoreboard__live-table-body--no-hits";
    return (React.createElement("tbody", { className: tableBodyClass, "data-uat": "scoreboard-live-table-body" },
        React.createElement(OnServeTeam1Scores, { scores: team1Scores, teamName: team1Name, onServe: onServe, sportId: sportId }),
        React.createElement(OnServeTeam2Scores, { scores: team2Scores, teamName: team2Name, onServe: onServe, sportId: sportId })));
};
//# sourceMappingURL=BaseballLiveTableBody.js.map